import { auth } from "db/config";

/**
 * Obtiene el ID del usuario autenticado.
 *  @return {string|null} El ID del usuario o null si no hay usuario autenticado.
 */
export const getUserId = () => {
  return auth.currentUser?.uid;
};

/**
 * Verifica si hay un usuario autenticado.
 * @return {boolean} true si hay un usuario autenticado, false en caso contrario.
 */
export const isAuthenticated = () => {
  return Boolean(getUserId());
};
